import { Box, Button, Center } from "@chakra-ui/react";
import RefreshOutlined from "../../assets/icons/Refresh";
import { useRive } from "@rive-app/react-canvas";

export type RepeatButtonProps = {
  label?: string;
  riveSrc: string;
  onClick?: (state: any, setState: any) => void;
  defaultState?: any;
  width?: number;
  height?: number;
};

const RepeatButton = ({ label, riveSrc, height, width }: RepeatButtonProps) => {
  const { rive, RiveComponent } = useRive({
    src: riveSrc,
    autoplay: true,
  });

  return (
    <Box>
      <RiveComponent
        style={{ width: width ?? "100%", height: height ?? "15rem" }}
      />
      <Center>
        <Button
          variant={"teronary"}
          onClick={() => {
            rive?.reset();
            rive?.play();
          }}
          leftIcon={<RefreshOutlined />}
        >
          {label ? label : "Repeat"}
        </Button>
      </Center>
    </Box>
  );
};

export default RepeatButton;
